
/**
isTargetEvent(e)
Tests `e.target === e.currentTarget`.
**/
export default function isTargetEvent(e) {
    return e.target === e.currentTarget;
}
